import { gql } from '@apollo/client'

export const GET_ALL_REPORT_GROUPS_BY = gql`
  query GetAllGroupsBy($offset: Int, $limit: Int, $searchQuery: String) {
    getAllGroupsBy(offset: $offset, limit: $limit, searchQuery: $searchQuery) {
      count
      rows {
        id
        name
        description
        icon
        icon_file_id
        IconOfGroup {
          id
          url
        }
      }
    }
  }
`

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: GroupInput!) {
    createGroup(input: $input) {
      id
      name
      description
      icon
      icon_file_id
    }
  }
`

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($updateGroupId: Int!, $input: GroupInput!) {
    updateGroup(id: $updateGroupId, input: $input)
  }
`

export const GET_ONE_GROUP = gql`
  query GetOneGroup($getOneGroupId: Int!) {
    getOneGroup(id: $getOneGroupId) {
      id
      name
      description
      icon
      icon_file_id
      allow_create_in_web
      allow_create_in_app
      show_system
      IconOfGroup {
        id
        url
      }
    }
  }
`
export const DELETE_GROUP = gql`
  mutation DeleteGroup($deleteGroupId: Int!) {
    deleteGroup(id: $deleteGroupId)
  }
`

export const GET_ALL_GROUPS_FOR_SELECT = gql`
  query GetAllGroups {
    getAllGroups {
      id
      name
    }
  }
`
